import { useQuery } from "@tanstack/react-query";
import { useAuthContext } from "@/auth/AuthProvider";
import { fetchExceptionsSummary } from "@/api/exceptions";
import { QUERY_KEYS, REFETCH_INTERVAL } from "@/config/constants";
import type { ExceptionsSummaryResponse } from "@/api/types";

export function useExceptionsSummary() {
  const { user } = useAuthContext();

  return useQuery<ExceptionsSummaryResponse>({
    queryKey: [...QUERY_KEYS.EXCEPTIONS.summary, user?.activeGroupId],
    queryFn: () => fetchExceptionsSummary(user!.activeGroupId),
    enabled: user !== null,
    refetchInterval: REFETCH_INTERVAL.FAST,
  });
}
